import "./SkeletonLoader.scss";

const SkeletonLoader = ({ className, isLoader1 }) => (
  <div className={`skeleton-loader ${className} ${isLoader1 ? "loader-one" : "loader-two"}`} />
);

export default SkeletonLoader;
